import { Component, ReactNode } from 'react';

import Dialog from '~src/shared/dialogs/dialog/Dialog';

import { AnonHeader, CloseAction, MobileModalContainer } from './mobileModal.sc';

interface DefaultProps {
  header: ReactNode | null;
}

interface Props extends DefaultProps {
  trigger: ReactNode;
  content: ReactNode;
}

interface State {
  open: boolean;
}

class MobileModal extends Component<Props, State> {
  static defaultProps = {
    header: null,
  };

  state = {
    open: false,
  };

  toggleInfo(open: boolean) {
    this.setState({ open });
  }

  openToggle = () => this.toggleInfo(true);
  closeToggle = () => this.toggleInfo(false);

  render() {
    return (
      <MobileModalContainer>
        <Dialog title="" show={this.state.open} onHide={this.closeToggle}>
          <div>
            <AnonHeader>
              {this.props.header}
              {/*tslint:disable-next-line:jsx-use-translation-function*/}
              <CloseAction onClick={this.closeToggle}>&#x2715;</CloseAction>
            </AnonHeader>
            {this.props.content}
          </div>
        </Dialog>
        <div onClick={this.openToggle}>{this.props.trigger}</div>
      </MobileModalContainer>
    );
  }
}

export default MobileModal;
